<template>
  <field
    :error="error"
    :autofocus="autofocus"
    :readonly="readonly"
    :label="$t(newLabel)"
    :classes="classes"
    v-model="newValue"
    :collection="newCollection"
    :name="name"
    :value="value"
    :placeholder="placeholder"
    :required="required"
    :defaultValue="defaultValue"
    :type="type"
    :helpIcon="helpIcon"
    :helpIconOptions="helpIconOptions"
    :enrich_tags="enrich_tags"
    :autocomplete="autocomplete"
    :disabled="disabled"
  />
</template>
<script>
import Field from "@/components/helpers/DataInput/FormField";

export default {
  components: { Field },
  props: {
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    classes: Array,
    name: String,
    autocomplete: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    helpIcon: {
      type: Boolean,
      default: false
    },
    helpIconOptions: {
      type: Object
    },
    value: {},
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      default: null
    },
    enrich_tags: false,
    collection: {},
    params: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Array,
      default: () => []
    },
    model: String,
    fromLeadMask: false
  },
  data() {
    return {
      newValue: "",
      error: undefined
    };
  },
  mounted() {
    this.newValue = this.value;
  },
  methods: {
    change(name, value) {
      this.newValue = value;
      this.$emit("change", this.newValue, this.name, name); // see: LeadUpdate#change for reasoning
    },
    removeObjectEvent(val) {
      // We have one unexpected extra item in our newValue event from 'FormField'.
      // This causes an extra item in our diff in LeadUpdate.diff().
      // We simply remove the extra item.
      if (val) {
        for (var value in val) {
          if (value == "[object Event]") {
            delete val["[object Event]"];
          }
        }
      }
    }
  },
  computed: {
    newLabel() {
      if (this.label) {
        if (this.label === "empty") {
          return "";
        }
        return this.label;
      } else {
        // here we return a fallback label, but only if we are not rendering from the LeadMask
        if(this.fromLeadMask) {
          return "";
        }
        return "models." + this.model + "." + this.name;
      }
    },
    newCollection() {
      if (!Array.isArray(this.collection)) {
        return this.collection;
      }

      if (this.collection) {
        let newCollection = [];
        this.collection.forEach(item => {
          let newItem;

          if (_.get(this.params, "no_i18n")) {
            newItem = { value: item.value, name: item.name };
          } else if (!this.label || this.label.length < 2) {
            newItem = {
              value: item.value,
              name: this.$t("models.select_" + this.name + "." + item.value)
            };
          } else {
            newItem = { value: item.value, name: item.name };
          }

          if (item.disabled) {
            newItem.disabled = item.disabled;
          }
          newCollection.push(newItem)
        })

        if(this.type == "radio"){
          if(_.get(this.params, 'empty_choice')){
            newCollection.push({value: "", name: "-"})
          }
        }
        return newCollection;
      }
    }
  },
  watch: {
    errors(errors) {
      this.error = undefined;
      this.errors.forEach(error => {
        if (error.field_name == this.name) {
          this.error = this.$t("errors." + error.code);
        }
      });
    },
    value(val) {
      if (val !== this.newValue) {
        this.newValue = val;
      }
    },
    newValue(val) {
      if (this.value !== val) {
        this.removeObjectEvent(val);
        this.$emit("input", val);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// Field.vue?024a020e